import apiClient, { setAuthToken } from './api.client';

const ensureAuth = () => {
  const tk = localStorage.getItem('token');
  if (tk) setAuthToken(tk);
};

const handleError = (err) => {
  if (err && err.response && err.response.status === 401) {
    const e = new Error('Unauthorized');
    e.status = 401;
    throw e;
  }
  throw err;
};

const AccountService = {
  getById: async (id) => {
    try {
      ensureAuth();
      const res = await apiClient.get(`/account/${id}`);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  update: async (id, data) => {
    try {
      ensureAuth();
      const res = await apiClient.patch(`/account/${id}`, data);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  getOrderStatuses: async (id) => {
    try {
      ensureAuth();
      const res = await apiClient.get(`/account/${id}/order-statuses`);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  updateOrderStatuses: async (id, items) => {
    try {
      ensureAuth();
      const res = await apiClient.patch(`/account/${id}/order-statuses`, items);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  getWhatsappMessages: async (id) => {
    try {
      ensureAuth();
      const res = await apiClient.get(`/account/${id}/whatsapp-messages`);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  updateWhatsappMessages: async (id, items) => {
    try {
      ensureAuth();
      const res = await apiClient.patch(`/account/${id}/whatsapp-messages`, items);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  getAddress: async (id) => {
    try {
      ensureAuth();
      const res = await apiClient.get(`/account/${id}/address`);
      return res.data;
    } catch (err) {
      if (err?.response?.status === 404) return null;
      handleError(err);
    }
  },

  upsertAddress: async (id, data) => {
    try {
      ensureAuth();
      const res = await apiClient.put(`/account/${id}/address`, data);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  getDeliveryNeighborhoods: async (id) => {
    try {
      ensureAuth();
      const res = await apiClient.get(`/account/${id}/delivery-neighborhoods`);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  getDeliveryNeighborhoodSuggestions: async (id) => {
    try {
      ensureAuth();
      const res = await apiClient.get(`/account/${id}/delivery-neighborhood-suggestions`);
      return Array.isArray(res.data) ? res.data : [];
    } catch (err) {
      handleError(err);
    }
  },

  upsertDeliveryNeighborhoods: async (id, items) => {
    try {
      ensureAuth();
      const res = await apiClient.put(`/account/${id}/delivery-neighborhoods`, { items });
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },

  deleteDeliveryNeighborhood: async (id, neighborhoodId) => {
    try {
      ensureAuth();
      const res = await apiClient.delete(`/account/${id}/delivery-neighborhoods/${neighborhoodId}`);
      return res.data;
    } catch (err) {
      handleError(err);
    }
  },
};

export default AccountService;
